import React, {FC, useEffect, useState} from "react";

const NoSSR: FC<any> = ({children}) => {
    const [isClient, setIsClient] = useState(false)

    useEffect(() => {
        setIsClient(true)
    }, [])

    return isClient ? children : null;
}

export default NoSSR;
